import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FormGroup, ValidationErrors } from '@angular/forms';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { getHttpHeaders } from '@commons/utility/util';

import { environment } from '@environments/environment';

import { ResponseValidation } from '@core/model/response/response-validation';
import { CustomResponseDto } from '../model/custom-response-dto';
import { PhoneValidationResult } from '../model/phone-validation-result';

@Injectable({
  providedIn: 'root',
})
export class ValidatorService {
  private apiUrl = environment.apiUrl;
  private validatePhoneNumberUrl = `${this.apiUrl}origination/validation/validate-phone-number/{phoneNumber}`;
  private incomeMinimalNumberUrl = `${this.apiUrl}origination/validation/validate-minimal-income/{income}`;
  private expenseMinimalMaximumUrl = `${this.apiUrl}origination/validation/validate-minimal-maximum-expenses/{expense}`;
  private headers = getHttpHeaders();

  constructor(private http: HttpClient) {}

  matchingInputsValidator(firstKey: string, secondKey: string) {
    return function (group: FormGroup): ValidationErrors | undefined {
      if (group.controls[firstKey].value !== group.controls[secondKey].value) {
        return {
          mismatch: true,
        };
      }
    };
  }

  /**
   * Validate if the input is a valid phone number
   * @param mobileNumber
   */
  public validateMobileNumber(mobileNumber: string): Observable<CustomResponseDto<boolean>> {
    return this.http.get<any>(this.validatePhoneNumberUrl.replace('{phoneNumber}', mobileNumber), {
      headers: this.headers,
    });
  }

  public nameOrLastNameIsValid(nameOrLastName: string): Observable<CustomResponseDto<boolean>> {
    return this.http.get<any>(`${this.apiUrl}origination/validation/validate-text/${nameOrLastName}`, {
      headers: this.headers,
    });
  }

  public validateReferentEquals(phoneOne: string, phoneTwo: string): Observable<CustomResponseDto<boolean>> {
    return this.http.get<any>(
      `${this.apiUrl}origination/validation/validate-referent-phone-equals/${phoneOne}/${phoneTwo}`,
      { headers: this.headers }
    );
  }

  //TODO: <Arnold> This function shall replace the previous one (validateMobileNumber).
  public validatePhoneNumber(phoneNumber: string): Observable<PhoneValidationResult | null> | null {
    return this.validateMobileNumber(phoneNumber).pipe(
      map((response: CustomResponseDto<boolean>) => {
        if (response.response == false) {
          return {
            message: response.message,
            result: {
              invalidNumber: true,
            },
          };
        } else {
          return {
            message: null,
            result: null,
          };
        }
      })
    );
  }

  public validateMinimalIncome(income: string): Observable<ResponseValidation | null> | null {
    return this.http.get<any>(this.incomeMinimalNumberUrl.replace('{income}', income), { headers: this.headers }).pipe(
      map((response: CustomResponseDto<boolean>) => {
        if (response.response == false) {
          return {
            message: response.message,
            result: {
              invalidIncome: true,
            },
          };
        } else {
          return {
            message: null,
            result: null,
          };
        }
      })
    );
  }

  public validateMinimalMaximaMaximumExpense(expense: string): Observable<ResponseValidation | null> | null {
    return this.http
      .get<any>(this.expenseMinimalMaximumUrl.replace('{expense}', expense), { headers: this.headers })
      .pipe(
        map((response: CustomResponseDto<boolean>) => {
          if (response.response == false) {
            return {
              message: response.message,
              result: {
                invalidExpense: true,
              },
            };
          } else {
            return {
              message: null,
              result: null,
            };
          }
        })
      );
  }
}
